import { ChevronLeft, ChevronRight } from 'lucide-react';

const TablePagination = () => {
  return (
    <div className="flex items-center justify-between p-5">
      <span className="text-sm text-slate-500">Showing 1 to 5 of 32 committees</span>

      <div className="flex gap-2">
        <button className="w-10 h-10 border rounded-xl flex items-center justify-center">
          <ChevronLeft size={16} />
        </button>

        <button className="w-10 h-10 rounded-xl bg-[#0E7490] text-white">1</button>

        <button className="w-10 h-10 border rounded-xl">2</button>

        <button className="w-10 h-10 border rounded-xl">3</button>

        <button className="w-10 h-10 border rounded-xl">4</button>

        <button className="w-10 h-10 border rounded-xl">...</button>

        <button className="w-10 h-10 border rounded-xl">8</button>

        <button className="w-10 h-10 border rounded-xl flex items-center justify-center">
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
